/* import __COLOCATED_TEMPLATE__ from './create-topic-button.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "",
  label: "topic.create",
  btnClass: "btn-default",
});
